import React from "react";
import Container from "react-bootstrap/Container";

import logoComplete from "../assets/images/logo-complete.png";

import styles from "../assets/styles/masthead.module.scss";

export function Masthead() {
  return (
    <section
      id={styles.clinic}
      className="d-flex align-items-center justify-content-center"
    >
      <Container
        className="d-flex align-items-center justify-content-center flex-column"
        data-aos="fade-up"
      >
        <img src={logoComplete} alt="Logo" className="img-fluid" />
      </Container>
    </section>
  );
}